import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShortLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6.52498 9.16667 2.98333-2.99167-1.175-1.175-5 5 5 5 1.175-1.175-2.98333-2.9917h10.14162v-1.66663z",
		fill: "#707a88"
	})
});
export { SvgShortLeft as ReactComponent };
